<!doctype html>

<ng-template #mobilePopupMenuTpl>
  <div class="mobile-sidebar">
    <app-chat-sidebar
        [isCollapsed]="false"
    ></app-chat-sidebar>
  </div>
  
</ng-template>
<div *ngIf="!loading">
  <q-main-layout
    showSettingsButton="true" 
    showNotificationTray="false"
    (settingsClicked)="onSettingsClicked($event)"
    compact="true"
    [mobilePopupMenuContent]="mobilePopupMenuTpl"
  >
    <router-outlet></router-outlet>
  </q-main-layout>
  <p-toast position="top-right" appendTo="body" [baseZIndex]="20000"></p-toast>
</div>

<app-settings-menu #settingsMenu>
</app-settings-menu>

<div *ngIf="loading" class="loading">
  <app-loader [isLoading]="loading"></app-loader>
</div>
